import { render, staticRenderFns } from "./ColaboradoresCarousel.vue?vue&type=template&id=7d35c3fa&"
import script from "./ColaboradoresCarousel.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradoresCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports